export const AGENDA_MGMT_ROUTES = {
  box                : 'disponibilidad/box',
  requestTLM         : 'oferta-telemedicina',
  requestOBC         : 'oferta-bloqueo-cierre',
  resolutions        : 'resoluciones',
  activeOffers       : 'ofertas/activas',
  requestProfessional: 'solicitudes/profesional',
};
